import type { ReactNode } from "react";

// The match workflow's floating footer: back on the left, the primary action on
// the right, pinned just above the bottom edge while the page scrolls.
//
// Shared because it was duplicated. The workflow's step footer and the result
// step's save row carried the same contract in two places, drifted apart (one
// grew `mt-10`, one stayed `justify-end`), and ended up level while scrolling
// but a row apart once the page bottomed out. One definition, one behaviour.
//
// sticky (not fixed) so the row respects the main-content container's right
// edge — fixed would overlap the agent sidebar when it's open (@adr SPARK-0019-assistant-lives-on-the-right-edge@1).
// pointer-events-none lets clicks fall through to the content passing beneath;
// each child re-enables pointer-events for its own clickable area.
export function FloatingActionRow({ children }: { children: ReactNode }) {
  return (
    <div className="pointer-events-none sticky bottom-4 z-[var(--z-raised)] mt-10 flex items-center justify-between sm:bottom-8">
      {children}
    </div>
  );
}
